// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-group-text.dark[data-v-0b859dbc]{border-top-color:#343a40;border-right-color:#343a40;border-bottom-color:#343a40}", ""]);
// Exports
module.exports = exports;
